import { Layout } from "@/components/Layout";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <Layout>
      <div className="max-w-xl mx-auto px-4 py-28 text-center">
        <div className="font-display font-black text-8xl text-[#22d3ee]">404</div>
        <h1 className="font-display font-extrabold uppercase tracking-wide text-3xl text-[#0f172a] mt-2">Race Not Found</h1>
        <p className="text-slate-500 mt-3">The page or race you're looking for doesn't exist or is no longer published.</p>
        <Link to="/races" className="inline-block mt-8 bg-[#0a1420] text-white font-bold px-6 py-3 rounded-lg hover:bg-[#22d3ee] hover:text-[#0a1420] transition-colors">Find Your Next Race</Link>
      </div>
    </Layout>
  );
}
